import { Component, Inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { BaseModalComponent } from "../base-modal/base-modal.component";

/** FLIP-79. Version and both bullet lists come from the announcement payload (see
 * UpdateCompleteModalService) - never hardcoded. Each section is independent and only
 * renders when it has at least one entry. */
export interface DialogUpdateCompleteData {
  version: string;
  newFeatures: string[];
  bugFixes: string[];
}

/**
 * "You're up to date!" / What's New modal, shown once per version per user (see
 * UpdateCompleteModalService for the seen-tracking). Built directly on app-base-modal,
 * same approach as FLIP-78's dialog-refresh.component.ts, for the Figma-specified
 * sundown -> parchment gradient and wisteria Close pill that the fixed
 * ConfirmationModalComponent wrapper doesn't support.
 */
@Component({
  selector: "app-dialog-update-complete",
  templateUrl: "./dialog-update-complete.component.html",
  styleUrls: ["./dialog-update-complete.component.scss"],
  standalone: true,
  imports: [CommonModule, BaseModalComponent],
})
export class DialogUpdateCompleteComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogUpdateCompleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogUpdateCompleteData
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
